import lazyLoading from './lazyLoading';
let isHistoryApi = !!(window.history && history.pushState);

export default {
    mode: isHistoryApi ? 'history' : 'hash',
    linkActiveClass: 'is-active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/login',
            component: lazyLoading('Login'),
            meta: {
                label: '登录',
                hidden: true
            }
        },
        {
            path: '/',
            redirect: {
                name: 'UserArticleReview'
            },
            meta: {
                label: '首页',
                hidden: true
            }
        },
        {
            path: '/audit',
            name: 'audit',
            meta: {
                icon: 'el-icon-setting',
                label: '审核',
                hidden: false,
                submenu: true
            },
            component: lazyLoading('Home'),
            children: [
                {
                    name: 'UserArticleReview',
                    path: 'user-article-review',
                    // component: lazyLoading('auditmanage/UserArticleReview', false),
                    component: lazyLoading('auditmanage/UserArticleReview'),
                    meta: {
                        label: '米读小说复审',
                        hidden: false
                    }
                },
                {
                    name: 'UserArticleReviewDetail',
                    path: 'user-article-review-detail',
                    component: lazyLoading('auditmanage/UserArticleReviewDetail'),
                    meta: {
                        label: '米读小说复审详情',
                        parent: 'UserArticleReview',
                        hidden: true
                    }
                },
                {
                    name: 'WhiteList',
                    path: 'white-list',
                    component: lazyLoading('auditmanage/WhiteList'),
                    meta: {
                        label: '米读小说白名单',
                        parent: 'UserArticleReview',
                        hidden: true
                    }
                },
                {
                    name: 'Rules',
                    path: 'rules',
                    component: lazyLoading('auditmanage/Rules'),
                    meta: {
                        label: '米读小说审核标准',
                        parent: 'UserArticleReview',
                        hidden: true
                    }
                }
            ]
        },
        //
        // {
        //   name: 'home',
        //   path: '/home',
        //   meta: {
        //     icon: 'fa-tachometer',
        //     label: '审核',
        //     nomenu: true
        //   },
        //   component: lazyLoading('auditmanage/home')
        // },
        // {
        //   path: '/auditmanage',
        //   meta: {
        //     icon: 'iconfont el-icon-tickets',
        //     expanded: false,
        //     label: '审核',
        //     noRedirect: true,
        //   },
        //   component: lazyLoading('auditmanage', true),
        //   children: [
        //     {
        //       name: 'UserArticleReview',
        //       path: 'user-article-review',
        //       component: lazyLoading('auditmanage/UserArticleReview'),
        //       meta: {
        //         label: '米读小说复审',
        //         nomenu: false,
        //       }
        //     },
        //     {
        //       name: 'UserArticleReviewDetail',
        //       path: 'user-article-review-detail',
        //       component: lazyLoading('auditmanage/UserArticleReviewDetail'),
        //       meta: {
        //         label: '米读小说复审详情',
        //         parent: 'UserArticleReview',
        //         nomenu: true
        //       }
        //     },
        //     {
        //       name: 'WhiteList',
        //       path: 'white-list',
        //       component: lazyLoading('auditmanage/WhiteList'),
        //       meta: {
        //         label: '米读小说白名单',
        //         parent: 'UserArticleReview',
        //         nomenu: true
        //       }
        //     },
        //   ]
        // },
        {
            path: '*',
            redirect: '/404',
            meta: {
                hidden: true
            }
        }
    ]
};
